var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper-movimentacao" }, [
    _c(
      "div",
      { staticClass: "tabela-movimentacao" },
      [
        _vm._m(0),
        _c("v-data-table", {
          staticClass: "elevation-1",
          attrs: {
            headers: _vm.headers2,
            height: "25vh",
            items: _vm.ativo_prop,
            sortable: "false",
            "items-per-page": 100000,
            "hide-default-footer": ""
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "tabela-movimentacao" },
      [
        _vm._m(1),
        _c("v-data-table", {
          staticClass: "elevation-1",
          attrs: {
            headers: _vm.headers,
            "fixed-header": "",
            height: "60vh",
            items: _vm.desserts,
            sortable: "false",
            "items-per-page": 100000,
            "hide-default-footer": ""
          },
          scopedSlots: _vm._u([
            {
              key: "header.name",
              fn: function(ref) {
                var header = ref.header
                return [_vm._v(" " + _vm._s(header.text.toUpperCase()) + " ")]
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("Movimentação")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("Desempenho")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }